import type { AchievementBackgroundProps } from '../Achievement';

export const GoldPlaceholder = ({ size }: AchievementBackgroundProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M30.5234 7.82812C33.4158 4.49922 38.5842 4.49922 41.4766 7.82812C43.5708 10.2384 46.7596 11.3987 49.9131 10.8984C54.2685 10.2075 58.2278 13.5302 58.3037 17.9395C58.3587 21.1319 60.0557 24.071 62.793 25.7148C66.5734 27.9853 67.4714 33.0755 64.6953 36.502C62.6855 38.9828 62.0957 42.3241 63.1357 45.3428C64.5725 49.5121 61.9883 53.9887 57.6592 54.8291C54.5249 55.4376 51.9258 57.6187 50.7822 60.5996C49.2029 64.717 44.3457 66.4846 40.4893 64.3457C37.697 62.797 34.303 62.797 31.5107 64.3457C27.6543 66.4846 22.7972 64.717 21.2178 60.5996C20.0742 57.6187 17.4751 55.4376 14.3408 54.8291C10.0117 53.9887 7.42752 49.5121 8.86426 45.3428C9.90435 42.3241 9.31454 38.9828 7.30469 36.502C4.52864 33.0755 5.42657 27.9853 9.20703 25.7148C11.9443 24.071 13.6413 21.1319 13.6963 17.9395C13.7722 13.5302 17.7314 10.2075 22.0869 10.8984C25.2404 11.3987 28.4292 10.2384 30.5234 7.82812Z"
      fill="#EAEAEC"
      stroke="#9FA3A7"
      strokeWidth="2"
    />
  </svg>
);
